import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { selectMarketplaceApproval } from "../slice/selector";
import { useMarketplaceSlice } from "../slice";

import Button from "components/Buttons";
import LoadingSpinner from "components/PageLoader/Spinner";
import {
  ApprovalInformationSection,
  CommonWrapper,
  MarketplaceApprovalStyles
} from "./styled";
import {
  COLLABORATION_TYPE,
  MARKETPLACE_APPROVE_OPTIONS,
  MARKETPLACE_REJECT_OPTIONS,
  rejectReasonOptions
} from "../Campaign/data";

const MarketplaceApproval = () => {
  const location = useLocation();

  const dispatch = useDispatch();
  const { actions } = useMarketplaceSlice();

  const { loading, data, error } = useSelector(selectMarketplaceApproval);

  const [selectedApprovalLabel, setSelectedApprovalLabel] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search).get("params");

    if (params) {
      dispatch(
        actions.fetchMarketplaceApprovalDetails({
          params
        })
      );
    }
  }, []);

  const handleMarketplaceStatusUpdate = ({
    status,
    collaboration_type,
    reject_reason,
    type,
    high_value
  }) => {
    const params = new URLSearchParams(location.search).get("params");

    dispatch(
      actions.updateMarketplaceRequestStatus({
        marketplace_id_hash: marketplace_data?.id_hash,
        campaignId: marketplace_data?.id,
        status,
        params,
        collaboration_type,
        reject_reason,
        type,
        high_value
      })
    );
  };

  const marketplace_data = data?.marketplace_data;

  const InfluncerServiceType =
    marketplace_data?.service_type?.toLowerCase() === "influencers";
  const NotInfluncerServiceType =
    marketplace_data?.service_type?.toLowerCase() !== "influencers";

  return (
    <CommonWrapper
      className={`${loading ? "common-loading" : "common-styles"}`}
    >
      {loading ? (
        <>
          <div className="loading-state">
            <LoadingSpinner color="#A049FC" width="20" height="20" />{" "}
            <span>Loading...</span>
          </div>
        </>
      ) : (
        <MarketplaceApprovalStyles>
          <div className="info-header">
            <h2>New Marketplace Approval</h2>
          </div>

          <div className="approval-information-container">
            <ApprovalInformationSection>
              <h3 className="section-title">UGC Marketplace Information</h3>

              <ul className="approval-details-grid">
                <li>
                  <span>Name</span>
                  <div className="profile-info">
                    <img
                      src={
                        marketplace_data?.user_details?.profile_image ||
                        "https://live-hashfame.sgp1.digitaloceanspaces.com/creator_profiles/default_profile.png"
                      }
                      alt="Profile"
                      className="avatar"
                    />
                    <p>{marketplace_data?.user_details?.name || "-"}</p>
                  </div>
                </li>

                <li>
                  <span>Company</span>
                  <p>{marketplace_data?.user_details?.company || "-"}</p>
                </li>

                <li>
                  <span>Designation</span>
                  <p>{marketplace_data?.user_details?.designation || "-"}</p>
                </li>

                <li>
                  <span>LinkedIn</span>
                  <p>
                    {marketplace_data?.user_details?.linkedin_profile_id || "-"}
                  </p>
                </li>

                <li>
                  <span>Created At</span>
                  <p>{marketplace_data?.user_details?.created_at || "-"}</p>
                </li>

                <li>
                  <span>Status</span>
                  <p>{marketplace_data?.status || "-"}</p>
                </li>

                <li>
                  <span>Email Verified</span>
                  <p>
                    {marketplace_data?.user_details?.email_verified
                      ? "Yes"
                      : "No"}
                  </p>
                </li>
              </ul>
            </ApprovalInformationSection>

            <ApprovalInformationSection>
              <h3 className="section-title">UGC Marketplace Details</h3>

              <ul className="approval-details-grid">
                <li>
                  <span>Platform</span>
                  <p>{marketplace_data?.request_details?.platform || "-"}</p>
                </li>

                <li>
                  <span>Service Type</span>
                  <p>{marketplace_data?.service_type || "-"}</p>
                </li>

                <li>
                  <span>Creator Count</span>
                  <p>
                    {marketplace_data?.request_details?.creator_count_min ||
                      "-"}{" "}
                    -
                    {marketplace_data?.request_details?.creator_count_max ||
                      "-"}
                  </p>
                </li>

                <li>
                  <span>Creator Range</span>
                  <p>
                    {marketplace_data?.request_details?.creator_range || "-"}
                  </p>
                </li>

                <li>
                  <span>Pan India</span>
                  <p>{marketplace_data?.is_pan_india ? "Yes" : "No"}</p>
                </li>

                <li>
                  <span>Any Language</span>
                  <p>{marketplace_data?.any_language ? "Yes" : "No"}</p>
                </li>

                <li>
                  <span>Brand</span>
                  <p>{marketplace_data?.request_details?.brand || "-"}</p>
                </li>

                <li>
                  <span>Budget</span>
                  <p>
                    ₹
                    {marketplace_data?.request_details?.budget?.toLocaleString() ||
                      "-"}
                  </p>
                </li>
              </ul>
            </ApprovalInformationSection>

            <ApprovalInformationSection>
              <h3 className="section-title">Marketplace Details</h3>

              <div className="common-details">
                <span>Description</span>
                <p>{marketplace_data?.description || "-"}</p>
              </div>

              <div className="common-details categories-card">
                <span>Categories</span>

                <div className="tags">
                  {marketplace_data?.request_details?.categories?.map(
                    (category) => (
                      <span key={category}>{category}</span>
                    )
                  )}
                </div>
              </div>

              <div className="common-details categories-card">
                <span>Deliverables</span>
                <div className="tags">
                  {marketplace_data?.request_details?.content_deliverable?.map(
                    (item) => (
                      <span key={item}>{item}</span>
                    )
                  )}
                </div>
              </div>
            </ApprovalInformationSection>

            <ApprovalInformationSection className="footer-section">
              <h3 className="section-title decision">Approval Decision</h3>

              {InfluncerServiceType && (
                <>
                  {marketplace_data?.status === "pending_approval" ? (
                    <div className="decision-section">
                      <div className="decision-group">
                        <h3 className="section-title">Approve</h3>

                        <div className="pill-container">
                          {COLLABORATION_TYPE?.map((reason) => (
                            <Button
                              key={reason.value}
                              type="button"
                              className="decision-pill approve"
                              colorScheme="success"
                              onClick={() =>
                                handleMarketplaceStatusUpdate({
                                  status: "approved",
                                  collaboration_type: reason.value
                                })
                              }
                            >
                              {reason.label}
                            </Button>
                          ))}
                        </div>
                      </div>

                      <div className="decision-group">
                        <h3 className="section-title">Reject</h3>

                        <div className="pill-container">
                          {rejectReasonOptions?.map((reason) => (
                            <Button
                              key={reason.value}
                              type="button"
                              className="decision-pill reject"
                              colorScheme="error"
                              onClick={() =>
                                handleMarketplaceStatusUpdate({
                                  status: "rejected",
                                  reject_reason: reason.value
                                })
                              }
                            >
                              {reason.label}
                            </Button>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="decision-result">
                      {marketplace_data?.status === "approved" ? (
                        <Button
                          type="button"
                          colorScheme="success"
                          className="decision-pill approve"
                          disabled
                        >
                          Approved as {marketplace_data?.collaboration_type}
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          colorScheme="error"
                          className="decision-pill reject"
                          disabled
                        >
                          Rejected - {marketplace_data?.rejected_reason}
                        </Button>
                      )}
                    </div>
                  )}
                </>
              )}

              {NotInfluncerServiceType && (
                <>
                  {marketplace_data?.status === "pending_approval" ? (
                    <div className="decision-section">
                      <div className="decision-group">
                        <h3 className="section-title">Approve</h3>

                        <div className="pill-container">
                          {MARKETPLACE_APPROVE_OPTIONS?.map((option) => (
                            <Button
                              key={option.value}
                              colorScheme="success"
                              onClick={() => {
                                setSelectedApprovalLabel(option.label);
                                handleMarketplaceStatusUpdate({
                                  status: "approved",
                                  ...(option.type && { type: option.type }),
                                  ...(option.high_value && {
                                    high_value: option.high_value
                                  })
                                });
                              }}
                            >
                              {option.label}
                            </Button>
                          ))}
                        </div>
                      </div>

                      <div className="decision-group">
                        <h3 className="section-title">Reject</h3>

                        <div className="pill-container">
                          {MARKETPLACE_REJECT_OPTIONS?.map((option) => (
                            <Button
                              key={option.value}
                              type="button"
                              className="decision-pill reject"
                              colorScheme="error"
                              onClick={() =>
                                handleMarketplaceStatusUpdate({
                                  status: "rejected"
                                })
                              }
                            >
                              {option.label}
                            </Button>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="decision-result">
                      {marketplace_data?.status === "approved" ? (
                        <Button
                          type="button"
                          colorScheme="success"
                          className="decision-pill approve"
                          disabled
                        >
                          {selectedApprovalLabel || "Approved"}
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          colorScheme="error"
                          className="decision-pill reject"
                          disabled
                        >
                          Rejected
                        </Button>
                      )}
                    </div>
                  )}
                </>
              )}
            </ApprovalInformationSection>
          </div>
        </MarketplaceApprovalStyles>
      )}
    </CommonWrapper>
  );
};

export default MarketplaceApproval;
